(() => {
 'use strict';
 if(!window.FultonsDraftPreview)return;
 const sinuosa=(window.FultonsDraftProducts||[]).find(product=>String(product.id).split('/').pop()==='15887276704127');
 if(sinuosa){
  const source="https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-calligaris-sinuosa-with-step-feet-20260913.png?v=1789324278";
  const captions=["Sinuosa bedside table with optional STEP feet","Sinuosa bedside table without optional feet - room setting","Sinuosa bedside table - curved drawer detail","Sinuosa bedside table - open drawer detail","Sinuosa bedside table without optional feet - bedside setting"];
  sinuosa.featuredImageUrl=source;
  sinuosa.images=sinuosa.images.map((im,index)=>({...im,...(index===0?{url:source}:{}),altText:captions[index]||im.altText}));
  sinuosa.verifiedOriginalCutoutUrls=[...new Set([...(sinuosa.verifiedOriginalCutoutUrls||[]),source])];
  sinuosa.descriptionHtml="<p>Sinuosa brings softly flowing surfaces to the bedside. Its two-drawer form combines useful storage with a gently sculpted profile, with push-pull drawers and no handles.</p><p><strong>Shown with optional STEP feet.</strong> Sinuosa is also available in a low configuration without these feet, as shown in the room-setting photographs. The starting price is for the bedside table without optional feet or a ceramic top.</p><p><strong>Sizes without optional feet or top:</strong> CS6216-N1: W60 × D52 × H43 cm. CS6216-N2: W75 × D52 × H43 cm. Optional STEP feet (CS6230) and ceramic tops are available separately.</p><p><a href=\"https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-sinuosa-catalogue-excerpt.pdf?v=1789171357\" target=\"_blank\" rel=\"noopener\">Download product specification sheet</a></p>";
 }
 if(new URLSearchParams(location.search).has('draft_product'))return;
 const images={
  "15887275524479": {
    "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-pure-menu-clean-background-20261011.png?v=1791754816",
    "altText": "Calligaris Pure bedside table"
  },
  "15887276704127": {
    "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-calligaris-sinuosa-menu-white-20260913.png?v=1789322882",
    "altText": "Sinuosa bedside table with optional STEP feet"
  },
  "15887278047615": {
    "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-velo-menu-clean-background-20261011.png?v=1791754824",
    "altText": "Calligaris Velo bedside table"
  }
};
 const apply=()=>{
  document.querySelectorAll('.living-test__card[data-product-id]').forEach(card=>{
   const choice=images[card.dataset.productId];
   if(!choice)return;
   const img=card.querySelector('.living-test__image img:not(.fultons-card-secondary)');
   if(!img||img.dataset.bedsideWhiteSource===choice.url)return;
   const source=width=>{const url=new URL(choice.url);url.searchParams.set('width',width);return url.href;};
   img.dataset.bedsideWhiteSource=choice.url;
   delete img.dataset.normalized;
   delete img.dataset.normalizedSource;
   img.crossOrigin='anonymous';
   img.alt=choice.altText;
   img.sizes='(max-width:749px) calc(50vw - 16px), (max-width:1023px) calc(50vw - 26px), calc(25vw - 19px)';
   img.srcset=[240,360,480,720,900].map(w=>source(w)+' '+w+'w').join(', ');
   img.src=source(900);
  });
 };
 document.addEventListener('fultons:catalogue-updated',apply);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});
 else apply();
})();
